export default {
	ru: {
		updateAvailable: 'Доступно обновление 🎉',
		update: 'обновить',
		cancel: 'отмена',
	},
};
